import * as React from 'react';
import { Checkbox, DateTime, TerritorySelect } from '../../components/forms';
import Section from '../../components/Section';
import { Product } from '../../product';
import HelpHint from '../../components/HelpHint';

type Props = {
  product: Product;
  setProduct: Function;
};

const setValue = (obj: Product, onChange: Function) => (
  field: string,
  newValue: any,
) =>
  onChange(
    Object.assign({}, obj, {
      [field]: newValue,
    }),
  );

export default function ProductAvailability(props: Props) {
  const handleOnChange = setValue(props.product, props.setProduct);

  return (
    <Section title="Availability" id="availability">
      <div className="flex flex-wrap">
        <div className="flex-auto w-70-ns w-100 pr2">
          <Checkbox
            label="Active?"
            field={['available']}
            id="available"
            defaultValue={props.product.available}
            onValueChange={handleOnChange}
            tooltip="Display in the 'Discover' section"
          />
          <DateTime
            label="Available from"
            field={['available_from']}
            id="available_from"
            defaultValue={props.product.available_from}
            onValueChange={handleOnChange}
          />
          <Checkbox
            label="Available Worldwide?"
            field={['available_worldwide']}
            id="available_worldwide"
            defaultValue={props.product.available_worldwide}
            onValueChange={handleOnChange}
            tooltip="Display this product to all users"
          />
          {!props.product.available_worldwide && (
            <TerritorySelect
              label="Available in"
              field={['available_in']}
              id="available_in"
              defaultValue={props.product.available_in}
              onValueChange={handleOnChange}
            />
          )}
        </div>
        <div className="flex-auto w-30-ns w-100 pl2">
          <HelpHint>
            Pre-Orders are currently not supported. The Available From let's you
            automatically display the product in Filtru on a later date. You can
            also specify the counrries in which the products should appear in.
          </HelpHint>
        </div>
      </div>
    </Section>
  );
}
